import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import Developer from "./pages/Developer/Developer"
import 'bootstrap'
import Nav from "./components/navbar";
import Footer from "./components/footer"

function App() {
  return (
    <div className="App">

    <Router>
     
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/Developer" element={<Developer />} />
                <Route path="/Developer" element={<Developer />} />
            </Routes>
        </Router>

    </div>
  );
}

export default App;
